import React from 'react';
import { Grid, Message } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { getOptions, modeChangedFromView } from '../../../../utils';
import CommonSelectInputWrapper from '../../../common/CommonSelectInputWrapper';
import connect from 'react-redux/es/connect/connect';
import CommonTagsInputWrapper from '../../../common/CommonTagsInputWrapper';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import CmrClassContainer from './CmrClassContainer';

import { chemicalProductsActions } from '../../../../behavior/chemicalProducts/index';
import { casNumbersActions } from '../../../../behavior/casNumbers';
import { unNumbersActions } from '../../../../behavior/unNumbers';
import { Mode } from '../../../../constants';
import { titlesActions } from '../../../../behavior/titles';
import { suppliersActions } from '../../../../behavior/suppliers';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import CPChemicalOtherContainer from './CPChemicalOtherContainer';
import { isProductEditor } from '@behavior/init/selectors';

class CPChemicalContainer extends React.Component {
  constructor(props) {
    super(props);
    if (props.mode != Mode.VIEW) {
      this.loadOnStart();
    }
  }

  componentWillReceiveProps(newProps) {
    if (modeChangedFromView(this.props, newProps)) this.loadOnStart();
  }

  loadOnStart = () => {
    const { casNumberList, unNumberList, supplierList } = this.props;
    if (!casNumberList || casNumberList.length == 0) this.props.getCasNumberList();
    if (!unNumberList || unNumberList.length == 0) this.props.getUnNumberList();
    if (!supplierList || supplierList.length == 0) this.props.getSupplierList();
  };

  render() {
    return (
      <AccordionWrapper
        {...this.props}
        accordionTitle="chemical.product.details.page.chemical.container.title"
        render={this.getChemicalContainerContent}
        className=""
        closable={false}
      />
    );
  }

  getTradeNameField = () => {
    const { values, disabled, chemicalProductDisabled, updateChemProdTitle } = this.props;
    return (
      <GridColumnInputWrapper
        {...this.props}
        width={12}
        value={values.chemicalProduct.tradeName || ''}
        name="chemicalProduct.tradeName"
        label="chemical.product.details.page.chemical.container.trade.name.input"
        disabled={disabled || chemicalProductDisabled}
        specialRequiredCondition={true}
        onChange={updateChemProdTitle}
        render={props => <InputWrapper {...props} />}
      />
    );
  };

  onStateChange = () => {
    this.props.debouncedUpdateRiskCalculations();
    this.props.stateChange();
  };

  isSupplierNew = () => {
    const { supplierList, values } = this.props;
    if (values.chemicalProduct.supplier && supplierList && supplierList.length > 0) {
      return !supplierList.some(c => c.id == values.chemicalProduct.supplier.id);
    }
    return false;
  };

  getChemicalContainerContent = () => {
    const {
      t,
      values,
      handleChange,
      errors,
      unNumberList,
      casNumberList,
      supplierList,
      initialData,
      disabled,
      chemicalProductDisabled,
    } = this.props;

    const stateList = getOptions(initialData.stateList, values.chemicalProduct.state, ['name']);
    const isSupplierNew = this.isSupplierNew();

    return (
      <Grid stackable columns={3} verticalAlign="bottom">
        {this.getTradeNameField()}
        <GridColumnInputWrapper
          {...this.props}
          width={4}
          value={values.chemicalProduct.state.id || ''}
          name="chemicalProduct.state.id"
          label="chemical.product.details.page.chemical.container.state.input"
          options={stateList}
          placeholder="select.input.default.placeholder"
          disabled={disabled || chemicalProductDisabled}
          onChange={this.onStateChange}
          propUsedInChanges="name"
          render={props => <CommonSelectInputWrapper {...props} />}
        />
        <GridColumnInputWrapper
          {...this.props}
          width={8}
          value={values.chemicalProduct.chemicalName || ''}
          name="chemicalProduct.chemicalName"
          label="chemical.product.details.page.chemical.container.chemical.name.input"
          handleChange={handleChange}
          disabled={disabled || chemicalProductDisabled}
          render={props => <InputWrapper {...props} />}
        />
        <GridColumnInputWrapper
          {...this.props}
          width={4}
          name="chemicalProduct.unNumber"
          label="chemical.product.details.page.chemical.container.un.number.input"
          errors={errors}
          disabled={disabled || chemicalProductDisabled}
          render={props => (
            <CommonTagsInputWrapper
              {...props}
              suggestionList={unNumberList}
              matchProperty="id.unNumber"
              displayProps="id.unNumber,id.dangerCode"
              value={values.chemicalProduct.unNumber}
              onSelect={() => this.props.setFieldValue('chemicalProduct.isNotRegulated', false)}
              maxTags={1}
              onlyUnique={true}
            />
          )}
        />
        <GridColumnInputWrapper
          {...this.props}
          width={4}
          fieldClassName="checkboxMargin"
          inputClassName="checkboxLabelOnTop"
          value={values.chemicalProduct.isNotRegulated}
          name="chemicalProduct.isNotRegulated"
          label="chemical.product.details.page.chemical.container.is.not.regulated.input"
          type="checkbox"
          disabled={disabled || chemicalProductDisabled}
          render={props => (
            <InputWrapper
              {...props}
              onChange={() => {
                if (values.chemicalProduct.isNotRegulated)
                  this.props.setFieldValue('chemicalProduct.unNumber', null);
              }}
            />
          )}
        />
        <GridColumnInputWrapper
          {...this.props}
          width={8}
          name="chemicalProduct.casNumber"
          label="chemical.product.details.page.chemical.container.cas.number.input"
          displayPropertyErrors="casNumber"
          disabled={disabled || chemicalProductDisabled}
          render={props => (
            <CommonTagsInputWrapper
              {...props}
              suggestionList={casNumberList}
              matchProperty="casNumber"
              displayProps="casNumber"
              value={values.chemicalProduct.casNumber}
              maxTags={1}
              onlyUnique={true}
              onlyAutocomplete={false}
            />
          )}
        />
        <CmrClassContainer width={8} {...this.props} />
        {isSupplierNew && (
          <Grid.Column width={16}>
            <div className="containerReducedWhiteSpace">
              <Message color="yellow">
                {t('chemical.product.details.page.new.supplier.warning')}
              </Message>
            </div>
          </Grid.Column>
        )}
        <GridColumnInputWrapper
          {...this.props}
          width={8}
          name="chemicalProduct.supplier"
          label="chemical.product.details.page.chemical.container.supplier.input"
          disabled={disabled || chemicalProductDisabled}
          render={props => (
            <CommonTagsInputWrapper
              {...props}
              suggestionList={supplierList}
              matchProperty="name"
              displayProps="name"
              value={values.chemicalProduct.supplier}
              maxTags={1}
              onlyUnique={true}
              onlyAutocomplete={false}
            />
          )}
        />
        {(values.chemicalProduct.scemCode ||
          !(disabled || chemicalProductDisabled || !isProductEditor(this.props.user))) && (
          <GridColumnInputWrapper
            {...this.props}
            width={8}
            name="chemicalProduct.scemCode"
            label="chemical.product.details.page.chemical.container.scem.code.input"
            disabled={disabled || chemicalProductDisabled || !isProductEditor(this.props.user)}
            render={props => <InputWrapper {...props} value={values.chemicalProduct.scemCode} />}
          />
        )}
        <Grid.Column width={16}>
          <CPChemicalOtherContainer {...this.props} />
        </Grid.Column>
      </Grid>
    );
  };
}

CPChemicalContainer.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  initialData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  ...state.unNumbers,
  ...state.casNumbers,
  ...state.suppliers,
});

const mapDispatchToProps = dispatch => ({
  getUnNumberList: () => dispatch(unNumbersActions.getUnNumberList()),
  getCasNumberList: () => dispatch(casNumbersActions.getCasNumberList()),
  getSupplierList: () => dispatch(suppliersActions.getSupplierList()),
  stateChange: () => dispatch(chemicalProductsActions.stateChange()),
  updateChemProdTitle: () => dispatch(titlesActions.updateChemProdTitle()),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CPChemicalContainer);
